import axios from 'axios';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { globalConfig, defaultConfigPath, developConfig } from './settings/global.config';

let Auth0ProviderWithNavigate = null;
let App = null;

axios
	.get(defaultConfigPath)
	.then(response => {
		globalConfig.set(response.data);
	})
	.catch(() => {
		if (process.env.NODE_ENV === 'development') {
			globalConfig.set(developConfig);
		} else {
			const errorMessage =
				'Error while fetching global config, the App wil not be rendered. (This is NOT a React error.)';
			return <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>;
		}
	})
	.then(() => {
		import('./auth0withNavigate')
			.then(auth0module => {
				Auth0ProviderWithNavigate = auth0module.default;

				import('./app')
					.then(appModule => {
						App = appModule.default;

						ReactDOM.render(
							<BrowserRouter>
								<Auth0ProviderWithNavigate>
									<App />
								</Auth0ProviderWithNavigate>
							</BrowserRouter>,
							document.getElementById('react-app')
						);
					})
					.catch(() => {
						const errorMessage = 'Error while loading application libraries.';
						return <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>;
					});
			})
			.catch(() => {
				const errorMessage = 'Error while authentication libraries.';
				return <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>;
			});
	});
